export default class CarModal {
  constructor () {
    this.MODAL = document.getElementById('popup-single-car')
    if (!this.MODAL) return
    this.CLOSE_BUTTON = this.MODAL.querySelector('.popup__close')
    this.BUTTONS = document.querySelectorAll('[data-popup-id="popup-single-car"], [href="#popup-single-car"]')

    this.init()
    this.populateHiddenInputs()
  }

  init () {
    if (this.BUTTONS.length > 0 && this.CLOSE_BUTTON) {
      for (let i = 0; i < this.BUTTONS.length; i++) {
        this.BUTTONS[i].addEventListener('click', (e) => {
          e.preventDefault()
          this.showPopup()
        })
      }

      this.CLOSE_BUTTON.addEventListener('click', (e) => {
        e.preventDefault()
        this.closePopup()
      })

      document.addEventListener('keydown', (e) => {
        if (e.key === "Escape") {
          this.closePopup()
        }
      })
    }
  }

  closePopup () {
    this.MODAL.classList.remove('popup--show')
  }

  showPopup () {
    this.MODAL.classList.add('popup--show')
  }

  populateHiddenInputs () {
    const CAR_TITLE = document.querySelector('input[name="single-car-title"]')
    const CAR_H2 = document.querySelector('.mtt-single-car-cover__title')
    const CAR_URL = document.querySelector('input[name="single-car-url"]')

    const DEALER_ID = this.MODAL.getAttribute('data-dealer_id')
    const DEALER_ID_INPUT = document.querySelector('input[name="dealer-id"]')
    const DEALER_NAME = this.MODAL.getAttribute('data-dealer_name')
    const DEALER_NAME_INPUT = document.querySelector('input[name="dealer-name"]')
    const DEALER_ZIP_CODE = this.MODAL.getAttribute('data-dealer_zip_code')
    const DEALER_ZIP_CODE_INPUT = document.querySelector('input[name="dealer-zip_code"]')

    if (CAR_TITLE && CAR_H2) CAR_TITLE.value = CAR_H2.textContent

    if (CAR_URL) CAR_URL.value = window.location.href

    if (DEALER_ID && DEALER_ID_INPUT) {
      DEALER_ID_INPUT.value = JSON.parse(DEALER_ID)
    }

    if (DEALER_NAME && DEALER_NAME_INPUT) {
      DEALER_NAME_INPUT.value = JSON.parse(DEALER_NAME)
    }

    if (DEALER_ZIP_CODE && DEALER_ZIP_CODE_INPUT) {
      DEALER_ZIP_CODE_INPUT.value = JSON.parse(DEALER_ZIP_CODE)
    }
  }
}
